var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCowMilk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3384_1418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4688 7.71875H19.4062L16.3125 3.58437V1.15625C16.3125 0.7625 16.0375 0.5 15.625 0.5H7.375C6.9625 0.5 6.6875 0.7625 6.6875 1.15625V2.92813L10.4688 7.71875Z",
    fill: "#118f84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4375 9.03125H3.25V11.6562V17.5625V18.2188H9.4375V9.03125Z",
    fill: "#118f84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8125 18.2188H19.75V17.5625V11.6562V9.03125H10.8125V18.2188Z",
    fill: "#118f84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 7.71895L6.1375 4.37207L3.59375 7.71895H8.75Z",
    fill: "#118f84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8125 19.5312V21.5H19.0625C19.475 21.5 19.75 21.2375 19.75 20.8438V19.5312H10.8125Z",
    fill: "#118f84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4375 19.5312H3.25V20.8438C3.25 21.2375 3.525 21.5 3.9375 21.5H9.4375V19.5312Z",
    fill: "#118f84"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3384_1418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 21,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCowMilk);
export default __webpack_public_path__ + "static/media/COW_MILK.9d5a6fe909398307676b9f2afc18b0e6.svg";
export { ForwardRef as ReactComponent };